import PropTypes from "prop-types";
import { Grid, Button, Divider, Typography } from "@mui/material";

import { SUPPORT_WEBSITE } from "@aclymatepackages/constants";

import SupportEmailForm from "../inputs/SupportEmailForm";

import { analyticsTrack } from "../../helpers/analytics";

const SupportSlider = ({
  showHelpCenter = true,
  setSupportSliderOpen,
  email,
  userName,
  companyName,
  subject,
  message,
}) => {
  return (
    <Grid container direction="column" spacing={2} wrap="nowrap">
      {showHelpCenter && (
        <>
          <Grid item container justifyContent="center" spacing={2}>
            <Grid item>
              <Button
                color="primary"
                variant="contained"
                href={SUPPORT_WEBSITE}
                target="_blank"
              >
                Visit our help center
              </Button>
            </Grid>
            <Grid item>
              <Button
                color="secondary"
                variant="contained"
                onClick={() => {
                  setSupportSliderOpen(false);
                  analyticsTrack("tour replay");
                }}
              >
                Replay product tour
              </Button>
            </Grid>
          </Grid>
          <Grid
            item
            container
            justifyContent="center"
            alignItems="center"
            spacing={1}
          >
            <Grid item xs={5}>
              <Divider />
            </Grid>
            <Grid item={1}>
              <Typography
                variant="subtitle1"
                color="textSecondary"
                align="center"
              >
                OR
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <Divider />
            </Grid>
          </Grid>
        </>
      )}
      <SupportEmailForm
        email={email}
        userName={userName}
        companyName={companyName}
        subject={subject}
        message={message}
      />
    </Grid>
  );
};
SupportSlider.propTypes = {
  showHelpCenter: PropTypes.bool,
  setSupportSliderOpen: PropTypes.func,
  email: PropTypes.string,
  userName: PropTypes.string,
  companyName: PropTypes.string,
  subject: PropTypes.string,
  message: PropTypes.string,
};

export default SupportSlider;
